import React from "react";
import { Input } from "antd";

export const InputCustom = ({ label, isTextArea, ...rest }) => {
  return (
    <div className="customInput">
      {label && <label className="inputLabel">{label}</label>}
      {isTextArea ? (
        <Input.TextArea {...rest} />
      ) : (
        <Input {...rest} />
      )}
    </div>
  );
};
